// cabang.service — guard + orkestrasi CRUD cabang + gembok. Port saveOutlet/outletDelete v0.18.
import { currentUser } from '@core/session';
import type { Outlet } from '@core/types';
import * as repo from './cabang.repo';

export const canManageCabang = (): boolean => { const u = currentUser(); return !!u && ['Owner', 'Manager'].includes(u.role); };

export interface CabangForm {
  kode: string; nama: string; kota: string; telp: string; wa: string; alamat: string; rekening: string; gmaps: string;
}

/** Simpan cabang. `existingKode`=null utk baru (kode wajib+unik); saat edit kode tak berubah. */
export async function saveCabang(existingKode: string | null, f: CabangForm, all: Outlet[]): Promise<void> {
  if (!canManageCabang()) throw new Error('Khusus Owner/Manager.');
  const nama = f.nama.trim();
  const fields = { nama, kota: f.kota.trim() || null, telp: f.telp.trim() || null, wa: f.wa.trim() || null, alamat: f.alamat.trim() || null, rekening: f.rekening.trim() || null, gmaps: f.gmaps.trim() || null };
  if (existingKode) {
    if (!nama) throw new Error('Nama wajib diisi.');
    await repo.updateCabang(existingKode, fields);
  } else {
    const kode = f.kode.trim().toUpperCase();
    if (!kode || !nama) throw new Error('Kode & nama wajib diisi.');
    if (all.some((o) => o.kode === kode)) throw new Error('Kode cabang sudah dipakai.');
    await repo.createCabang({ kode, gembok: false, ...fields });
  }
}

/** Hapus cabang: min 1 cabang, tak boleh ada tiket/karyawan yang menautkannya. */
export async function deleteCabang(kode: string, totalCabang: number): Promise<void> {
  if (!canManageCabang()) throw new Error('Khusus Owner/Manager.');
  if (totalCabang <= 1) throw new Error('Minimal 1 cabang.');
  if ((await repo.ticketCount(kode)) > 0) throw new Error('Cabang masih punya data servis — tak bisa dihapus.');
  if ((await repo.employeeCount(kode)) > 0) throw new Error('Cabang masih punya karyawan — pindahkan/keluarkan dulu.');
  if ((await repo.customerCount(kode)) > 0) throw new Error('Cabang masih punya pelanggan — pindahkan dulu.');
  if ((await repo.overrideCount(kode)) > 0) throw new Error('Cabang masih punya override harga jasa — hapus dulu.');
  await repo.removeCabang(kode);
}

/** Kunci/buka toko (gembok) per cabang. */
export async function toggleGembok(kode: string, gembok: boolean): Promise<void> {
  if (!canManageCabang()) throw new Error('Tidak punya akses mengunci toko.');
  await repo.updateCabang(kode, { gembok });
}
